import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IPageNavigator } from "@models/entity-models";

@Kbo(CToken.PageNavigator)
export class PageNavigator extends UiObject implements IPageNavigator {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public buttonStyle: string;
    public showPageLabel: boolean;
    public labelColor: string;
}
